import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_CHATFLOW = createAsyncActionTypes('FETCH_CHATFLOW');
export const FETCH_CHATFLOW_CONNECTION_STATUS = createAsyncActionTypes('FETCH_CHATFLOW_CONNECTION_STATUS');